import React from 'react';
import AccountBasicInfoComponent from './add-account.components';
import AgentLoginInfoComponent from './agent-login-info.component';
import AgentUserProfileInfoComponent from './agent-userProfile.component';
import TransportAgentInfoComponent from './transport-agent-info.component';
import AgentAccountInfoComponent from './agent-account-info.component';
import { AddressContainer } from '../../../../../common/address/containers/address.container';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';

export const AgentComponent = ({ accounts, vehicles, salesOrders, transportAgents, selectedAgents, id, selectedAccounts, handleInnerFormChange, back, handleFormSubmit }: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'TransportAgent-Info',
            component: (
                <AccountBasicInfoComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedAccounts={selectedAccounts}
                />
            ),
            isVisible: id === String(0) ? true : false,
        },
        {
            id: 2,
            title: 'Login-Info',
            component: (
                <AgentLoginInfoComponent
                    onInnerFormChange={handleInnerFormChange}
                    selectedAgents={selectedAgents}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 3,
            title: 'User-Info',
            component: (
                <AgentUserProfileInfoComponent
                    onInnerFormChange={handleInnerFormChange}
                    selectedAgents={selectedAgents}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 4,
            title: 'RapAgent-Info',
            component: (
                <TransportAgentInfoComponent
                    transportAgents={transportAgents}
                    salesOrders={salesOrders}
                    vehicles={vehicles}
                    onInnerFormChange={handleInnerFormChange}
                    selectedAgents={selectedAgents}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 5,
            title: 'Account-Info',
            component: (
                <AgentAccountInfoComponent
                    accounts={accounts}
                    onInnerFormChange={handleInnerFormChange}
                    selectedAgents={selectedAgents}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 6,
            title: 'Address-Info',
            component: (
                <AddressContainer
                    onInnerFormChange={handleInnerFormChange}
                    selectedAddress={selectedAgents}
                />

            ),
            isVisible: id > 0 ? true : false
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default AgentComponent;
